(function () {
  'use strict';
  var labels = { twin: 'Twin', twinxl: 'Twin XL', full: 'Double', queen: 'Queen', king: 'King', calking: 'California King' };
  function normalizeSize(value) {
    var key = String(value || '').toLowerCase().replace(/[^a-z]/g, '');
    var aliases = { twin: 'twin', twxl: 'twinxl', twinxl: 'twinxl', full: 'full', double: 'full', fulldouble: 'full', doublefull: 'full', queen: 'queen', king: 'king', calking: 'calking', californiaking: 'calking' };
    return Object.prototype.hasOwnProperty.call(aliases, key) ? aliases[key] : null;
  }
  function summarize(variants, size) {
    var options = variants.filter(function (v) {
      return v.available === true && Number.isFinite(v.price) && v.price >= 0 && v.id &&
        !/split|system|base|short|\brv\b/i.test(v.title || '') &&
        Array.isArray(v.options) && v.options.some(function (option) { return normalizeSize(option) === size; });
    }).sort(function (a, b) { return a.price - b.price; });
    if (!options.length) return null;
    var first = options[0];
    var feels = [];
    options.forEach(function (v) {
      v.options.forEach(function (option) {
        var names = { firm: 'Firm', medium: 'Medium', soft: 'Plush', plush: 'Plush', mediumfirm: 'Medium-Firm' };
        var key = String(option).toLowerCase().replace(/[^a-z]/g, '');
        var feel = Object.prototype.hasOwnProperty.call(names, key) ? names[key] : null;
        if (feel && feels.indexOf(feel) === -1) feels.push(feel);
      });
    });
    feels.sort(function (a, b) { return ['Firm', 'Medium-Firm', 'Medium', 'Plush'].indexOf(a) - ['Firm', 'Medium-Firm', 'Medium', 'Plush'].indexOf(b); });
    return { variant: first, price: first.price, compare: Math.max(first.price, Number(first.compare_at_price) || 0), varying: options[options.length - 1].price !== first.price, feels: feels };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { normalizeSize: normalizeSize, summarize: summarize };
  if (typeof document === 'undefined') return;

  function initialize(scope) {
    scope.querySelectorAll('[data-sale-size-shopping]').forEach(function (root) {
      if (root.dataset.sizeReady) return;
      var cards = Array.from(root.querySelectorAll('.m-card'));
      var data;
      try {
        data = cards.map(function (card) { return JSON.parse(card.querySelector('[data-sale-variants]').textContent); });
        if (data.some(function (variants) { return !Array.isArray(variants); })) return;
      } catch (error) { return; } // Preserve the server-rendered Queen grid if data cannot be read.
      root.dataset.sizeReady = 'true';
      var size = normalizeSize(new URL(window.location.href).searchParams.get('mm_size')) || 'queen';
      var filter = 'all';
      var sizeButtons = Array.from(root.querySelectorAll('[data-sale-size]'));
      var filterButtons = Array.from(root.querySelectorAll('.m-chips .m-chip'));
      var count = root.querySelector('.m-count');
      var empty = root.querySelector('.m-size-empty');
      var baseHrefs = cards.map(function (card) { return card.href; });
      var defaultFeels = cards.map(function (card) { return card.querySelector('.m-feels').childNodes[0].textContent.trim(); });
      var filterLabels = { hot: 'sleeping hot', back: 'sore backs', couples: 'couples' };
      function money(cents) {
        return '$' + (cents / 100).toLocaleString('en-CA', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
      }
      function element(card, selector, tag, host) {
        var el = card.querySelector(selector);
        if (!el) {
          el = document.createElement(tag); el.className = selector.slice(1);
          var parent = card.querySelector(host);
          var before = selector === '.m-was' ? card.querySelector('.m-now') : host === '.m-body' ? card.querySelector('.m-cta') : null;
          parent.insertBefore(el, before);
        }
        return el;
      }
      function apply() {
        var shown = 0;
        var available = 0;
        var results = data.map(function (variants) { return summarize(variants, size); });
        // Reorder actual nodes so keyboard and screen-reader order match the visible price sort.
        var sorted = cards.map(function (card, index) { return { card: card, index: index, result: results[index] }; });
        if (filter === 'value') sorted.sort(function (a, b) { return (a.result ? a.result.price : Infinity) - (b.result ? b.result.price : Infinity) || a.index - b.index; });
        sorted.forEach(function (entry) {
          var card = entry.card, result = entry.result, index = entry.index;
          root.querySelector('.m-grid').appendChild(card);
          if (result) available++;
          var relevant = filter === 'all' || filter === 'value' || card.getAttribute('data-' + filter) === '1';
          var visible = !!result && relevant;
          card.classList.toggle('m-off', !visible);
          if (!visible) return;
          shown++;
          var url = new URL(baseHrefs[index]);
          url.searchParams.set('variant', result.variant.id);
          card.href = url.href;
          element(card, '.m-now', 'div', '.m-body').textContent = (result.varying ? 'From ' : '') + money(result.price);
          var was = element(card, '.m-was', 'div', '.m-body');
          was.textContent = money(result.compare); was.hidden = result.compare <= result.price;
          var saving = element(card, '.m-save', 'div', '.m-img');
          saving.textContent = 'Save ' + money(result.compare - result.price); saving.hidden = was.hidden;
          element(card, '.m-sz', 'div', '.m-body').textContent = labels[size] + ' mattress' + (result.varying ? ' · price varies by feel' : '');
          var monthly = element(card, '.m-mo', 'div', '.m-body');
          monthly.textContent = 'Or ' + (result.varying ? 'from ' : '');
          var amount = document.createElement('strong'); amount.textContent = '$' + Math.ceil((result.price + 9000) / 1200) + '/mo';
          monthly.appendChild(amount);
          monthly.appendChild(document.createTextNode(' · 12 months at 0%*'));
          var feels = card.querySelector('.m-feels');
          feels.textContent = result.feels.length ? result.feels.join(' · ') : defaultFeels[index];
          if (result.feels.length > 1 && !result.varying) {
            var same = document.createElement('span'); same.className = 'm-same'; same.textContent = 'Same price, available feels'; feels.appendChild(same);
          }
          var why = card.querySelector('.m-why');
          why.textContent = filterLabels[filter] ? (card.getAttribute('data-why-' + filter) || '') : '';
          why.classList.toggle('m-off', !why.textContent);
        });
        sizeButtons.forEach(function (button) {
          var selected = button.dataset.saleSize === size;
          button.setAttribute('aria-pressed', String(selected)); button.classList.toggle('on', selected);
        });
        filterButtons.forEach(function (button) {
          var selected = button.dataset.f === filter;
          button.setAttribute('aria-pressed', String(selected)); button.classList.toggle('on', selected);
          if (button.dataset.f === 'all') button.textContent = 'All mattresses';
        });
        count.textContent = shown + ' ' + labels[size] + ' mattress' + (shown === 1 ? '' : 'es') +
          (filter === 'value' ? ' · lowest price first' : filterLabels[filter] ? ' to compare for ' + filterLabels[filter] : ' to compare') + '.';
        if (filter !== 'all') {
          var reset = document.createElement('button'); reset.type = 'button'; reset.textContent = 'Show all ' + labels[size] + ' mattresses';
          reset.addEventListener('click', function () { filter = 'all'; apply(); });
          count.appendChild(document.createTextNode(' ')); count.appendChild(reset);
        }
        empty.hidden = shown > 0;
        empty.querySelector('p').textContent = available ? 'No matches for this combination. Keep your size and choose All mattresses to see your options.' : 'No mattresses in this size are available to order here right now. Choose another size or ask your local store for help.';
      }
      sizeButtons.forEach(function (button) { button.addEventListener('click', function () {
        size = button.dataset.saleSize;
        var url = new URL(window.location.href); url.searchParams.set('mm_size', size);
        try { window.history.replaceState(window.history.state, '', url.href); } catch (error) { /* Filtering still works without history access. */ }
        apply();
      }); });
      filterButtons.forEach(function (button) { button.addEventListener('click', function () { filter = button.dataset.f; apply(); }); });
      window.addEventListener('popstate', function () { size = normalizeSize(new URL(window.location.href).searchParams.get('mm_size')) || 'queen'; apply(); });
      apply();
      root.querySelector('.m-size-picker').hidden = false;
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
